var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn-rounded', ("is-" + _vm.theme)],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[_c('uhv-svg-icon',{attrs:{"icon":("chevron-" + _vm.direction)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }